(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-customer-reviews"] && !Shopify.designMode) return;
  try {
    
$(window).bind("load", function() { 
    var slickDots = $('.testi .slick-dots').width();
	//console.log('INNN ' + slickDots);
	//$('.testi .slick-arrow.prev').css('left','clac(50% - '+slickDots+'px')');
	//$('.testi .slick-arrow.next').css('right','clac(50% - '+slickDots+'px')');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
/* Swiper JS Initialization */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    new Swiper('.collection-slider', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
